
    const _each = require("lodash/each");
    const _times = require("lodash/times");
    const _escape = require("lodash/escape");
    const _throttle = require("lodash/throttle");

    const _ = {
        each: _each,
        times: _times,
        escape: _escape,
        throttle: _throttle,
    };

    module.exports = function(context) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="fullscreen-gallery" is="fullscreen-gallery"><div class="fullscreen-overlay"><div class="fullscreen-overlay-left"><div is="slide-control" selected-index="' +
__e( context.selectedItemIndex ) +
'" white-loading-indicator="true" ';
 if (context.options.zoomEnabled) { ;
__p += 'zoom-enabled="true"';
 } ;
__p += ' items=\'' +
__e( JSON.stringify(context.items) ) +
'\'></div>';
 if (context.items.length > 1) { ;
__p += '<button class="fullscreen-overlay-prev hidden-tablet" type="button" data-prev-button><div class="fullscreen-overlay-prev-glyph glyph glyph-large glyph-chevron-white glyph-mirror-x"></div></button><button class="fullscreen-overlay-next hidden-tablet" type="button" data-next-button><div class="fullscreen-overlay-next-glyph glyph glyph-large glyph-chevron-white"></div></button>';
 } ;
__p += '</div><div class="fullscreen-overlay-right"><ul class="fullscreen-overlay-thumbnails">';
 if (context.items.length > 1) { ;

 _.each(context.items, function(item, idx) { ;

 if (item.type === 'image') { ;
__p += '<li class="fullscreen-overlay-thumbnail-item"><a href="' +
__e( item.full_size_url ) +
'" class="fullscreen-overlay-thumbnail" data-item-id="' +
__e( idx ) +
'"><img is="lazy-image" image-src="' +
__e( item.thumbnail_url ) +
'" /></a></li>';
 } ;

 }) ;

 } ;

 if (context.viewSimilarEnabled) { ;
__p += '<li class="fullscreen-overlay__view-similar"><div class="fullscreen-overlay-inner"><h3 class="mb15">' +
__e( context.soldOutTitle ) +
'</h3><a href="#relatedproducts" class="btn btn--full-width">' +
__e( context.seeSimilarItemsBtnText ) +
'</a><div class="fullscreen-overlay__or-block"><span>' +
__e( context.orSeparator ) +
'</span></div><div>' +
((__t = ( context.seeNewItemsByDesignerHTML )) == null ? '' : __t) +
'</div></div></li>';
 } ;

 if (context.retailer) { ;
__p += '<li class="fullscreen-overlay__buy"><div class="fullscreen-overlay-inner"><span class="fullscreen-overlay-price heading-2 block mb10">';
 if (context.retailer.sale_price) { ;
__p += '<del>' +
__e( context.retailer.price ) +
'</del><span class="price sale">' +
__e( context.retailer.sale_price ) +
'</span>';
 } else { ;
__p +=
__e( context.retailer.price );
 } ;
__p += '</span><span class="fullscreen-overlay-retailer block mb15">' +
__e( context.atRetailerText ) +
'</span><a href="' +
__e( context.retailer.url ) +
'" class="btn btn--full-width" target="_blank" is="lead-link" reason="fullscreen-overlay-button">' +
__e( context.buyBtnText ) +
'</a></div></li>';
 } ;
__p += '</ul></div><div class="fullscreen-overlay-indicators"><div is="slide-indicators"max-slides="' +
__e( context.items.length ) +
'"selected-index="' +
__e( context.selectedItemIndex ) +
'"></div></div><button type="button" class="fullscreen-overlay-close glyph glyph-medium glyph-cross-white"><span class="fullscreen-overlay-close-text">' +
__e( context.closeBtnText ) +
'</span></button></div></div>';
return __p
};
    